import {
  IS_STATUS_LOADING,
  IS_STATUS_NOT_LOADING,
  UPDATE_ALERT_MODAL,
  UPDATE_SCHOOL_STATUS,
  STOP_SHOW_ALERT_ROOM,
  UPDATE_PENDING_ALERT_TYPES
} from '../actions/statusActions';

import { AlertTypes } from '../../constants';

const initialState = {
  schoolStatus: AlertTypes.UNKNOWN,
  isLoading: false,
  showAlertModal: false,
  showAlertRoom: false,
  roomID: null,
  // Whether the school-wide status in force is a drill.
  isDrill: false,
  // Names of alert types this school's badges cannot show yet, so the
  // dashboard cannot set them. Until the server says otherwise, assume none
  // of the new ones can be.
  pendingAlertTypes: ['Secure', 'Shelter', 'Evacuate', 'Fire']
};

const status = (state = initialState, action) => {
  switch (action.type) {
    case IS_STATUS_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case IS_STATUS_NOT_LOADING:
      return {
        ...state,
        isLoading: false
      };
    case UPDATE_SCHOOL_STATUS:
      var alertStatus = Object.values(AlertTypes).find(alertStatus => action.status.getDashboardStatus() === alertStatus.getDashboardStatus()) || AlertTypes.UNKNOWN;
      // Any change to a different alert is news. This compared ids, as if a
      // higher id were more severe: Hold (11) to Emergency (10) never
      // announced itself, nor would Secure (12) to Emergency.
      var isNewStatus = alertStatus.getID() !== state.schoolStatus.getID();

      return {
        ...state,
        schoolStatus: alertStatus,
        showAlertModal: alertStatus !== AlertTypes.NORMAL ? isNewStatus : false,
        showAlertRoom: action.roomID != null && isNewStatus && alertStatus !== AlertTypes.NORMAL && alertStatus !== AlertTypes.ALL_CLEAR,
        roomID: action.roomID,
        isDrill: action.isDrill === true
      };
    case UPDATE_ALERT_MODAL:
      return {
        ...state,
        showAlertModal: action.value
      };
    case UPDATE_PENDING_ALERT_TYPES:
      return {
        ...state,
        pendingAlertTypes: action.names
      };
    case STOP_SHOW_ALERT_ROOM:
      return {
        ...state,
        showAlertRoom: false,
        roomID: null
      };
    default:
      return state;
  }
};

export default status;
